export const ApiParams = {
  page_type: 'page_type',
  page_slug: 'page_slug',
  page_id: 'page_id',
  form_slug: 'form_slug',
  project_slug: 'project_slug',
  cat_slug:'cat_slug'
};
